import React from "react";
import { Grid, Divider } from "@material-ui/core";
import {
  MasterButton,
  InputOptionMaster,
  InputTextMaster,
} from "App/Component/ui";
import { TYPE_INSTANCE4 } from "App/constants";
import { useSelectOption } from "App/hooks";
import { RESET_STATE_FORM_FILTER } from "./helpers";
import DatePicker from "react-datepicker";
import moment from "moment";
import { isNull } from "App/utils/helpers";
import { status_kebutuhan } from "../InputRequest/helpers";
export default function FormFilterDaftarRequest({
  formFilter,
  setFormFilter,
  setNewData,
  typeButton = "submit",
}) {
  const handleChange = (text) => (e) => {
    setFormFilter({
      ...formFilter,
      [text]: e.target.value,
    });
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    await setNewData();
  };

  const unit = useSelectOption(
    true,
    "/wmsmaster/unit/read_gudang_farmasi",
    TYPE_INSTANCE4
  );

  return (
    <>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={3}>
          <Grid item sm={3}>
            <InputTextMaster
              type="number"
              name='id_request'
              label='ID REQUEST'
              id='id_request'
              value={formFilter.id_request}
              onChange={handleChange("id_request")}
              placeholder='ID REQUEST'
            />
          </Grid>
          <Grid item sm={3}>
            <InputTextMaster
              name='nama_request'
              label='NAMA REQUEST'
              id='nama_request'
              value={formFilter.nama_request}
              onChange={handleChange("nama_request")}
              placeholder='NAMA REQUEST'
            />
          </Grid>
          <Grid item sm={3}>
            <InputOptionMaster
                name="status_kebutuhan_id"
                label="TINGKAT STATUS KEBUTUHAN"
                id="status_kebutuhan_id"
                withSearch={true}
                data={status_kebutuhan}
                value={formFilter?.status_kebutuhan}
                labelValue={formFilter?.status_kebutuhan_nama}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormFilter({
                      ...formFilter,
                      status_kebutuhan: "",
                      nama_status_kebutuhan: "Pilih Status",
                    });
                  } else {
                    setFormFilter({
                      ...formFilter,
                      status_kebutuhan: e.value,
                      nama_status_kebutuhan: e.label,
                    });
                  }
                }}
              />
            </Grid>
          <Grid item sm={3}>
              <InputOptionMaster
                name="id_unit"
                label="UNIT"
                id="id_unit"
                withSearch={true}
                value={formFilter.unit_id}
                labelValue={formFilter.unit}
                onChange={(e) => {
                  if (isNull(e)) {
                    setFormFilter({
                      ...formFilter,
                      unit_id: "",
                      unit: "Pilih Unit",
                    });
                  } else {
                    setFormFilter({
                      ...formFilter,
                      unit_id: e.value,
                      unit: e.label,
                    });
                  }
                }}
                data={unit}
                error={true}
              />
            </Grid>

          <Grid item sm={6}>
            <label htmlFor='date' className='form-control-label'>
              TANGGAL AWAL
            </label>
            <DatePicker
              id='date'
              autoComplete='off'
              className='form-control text'
              dateFormat='dd/MM/yyyy'
              timeIntervals={5}
              locale='id-ID'
              selected={moment(formFilter.tglAwal).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAwal: e,
                });
              }}
              placeholderText='Tanggal'
            />
          </Grid>
          <Grid item sm={6}>
            <label htmlFor='date' className='form-control-label'>
              TANGGAL AKHIR
            </label>
            <DatePicker
              id='date'
              autoComplete='off'
              className='form-control text'
              dateFormat='dd/MM/yyyy'
              timeIntervals={5}
              locale='id-ID'
              selected={moment(formFilter.tglAkhir).toDate()}
              onChange={(e) => {
                setFormFilter({
                  ...formFilter,
                  tglAkhir: e,
                });
              }}
              placeholderText='Tanggal'
            />
          </Grid>
        </Grid>
        <br />
        <Grid
          container
          direction='row'
          justifyContent='space-between'
          alignItems='center'>
          <MasterButton
            name={"RESET"}
            outline={true}
            color={"danger"}
            type={"button"}
            size={"md"}
            onClick={() => setFormFilter(RESET_STATE_FORM_FILTER)}
          />
          <MasterButton
            name={"CARI"}
            outline={true}
            color={"green"}
            onClick={handleSubmit}
            type={typeButton}
            size={"md"}
          />
        </Grid>
        <br />
      </form>
      <Divider />
    </>
  );
}
